import { notify } from '@kyvg/vue3-notification';

const localState = {
  showFatalErrorModal: false,
  errorMessage: '',
  debugLink: '',
  fatalErrorTitle: '',
  fatalErrorText: '',
  logoutMessageId: null,
};

const NOTIFY_DEFAULTS = {
  error: {
    group: 'default',
    type: 'error',
    title: 'Error',
    duration: 7500,
  },
  warning: {
    group: 'default',
    type: 'warning',
    title: 'Warning',
    duration: 7500,
  },
  success: {
    group: 'default',
    type: 'success',
    title: 'Success',
    duration: 3000,
  },
  info: {
    group: 'default',
    type: 'info',
    title: 'Info',
    duration: 6000,
  },
};

const localGetters = {
  showFatalErrorModal: state => state.showFatalErrorModal,
  errorMessage: state => state.errorMessage,
  debugLink: state => state.debugLink,
  fatalErrorTitle: state => state.fatalErrorTitle,
  fatalErrorText: state => state.fatalErrorText,
  logoutMessageId: state => state.logoutMessageId,
};

const localActions = {
  push(ctx, notificationObj) {
    const params = { ...NOTIFY_DEFAULTS[notificationObj.type || 'error'], ...notificationObj };
    if (params.type === 'warning') params.type = 'warn';
    notify(params);
  },

  toggleFatalErrorModal({ commit }, payload) {
    commit('toggle_fatal_error_modal', payload);
  },

  setLogoutId({ commit }, id) {
    commit('set_logout_id', id);
  },
};

const localMutations = {
  toggle_fatal_error_modal(state, { errorMessage = '', debugLink = '', title = '', text = '', bool = false }) {
    state.errorMessage = errorMessage;
    state.debugLink = debugLink;
    state.fatalErrorTitle = title;
    state.fatalErrorText = text;
    state.showFatalErrorModal = bool;
  },

  set_logout_id(state, id) {
    state.logoutMessageId = id;
  },
};

export default {
  namespaced: true,
  state: localState,
  getters: localGetters,
  actions: localActions,
  mutations: localMutations,
};
